import { PiFactoryDuotone } from 'react-icons/pi';

import Node, { Button, NodeValue, NodeValueList } from 'app/admin/optimizationPipelineV2/component/pipeline/nodes/base/Node';

import { useOptimizationPipeline } from 'app/admin/optimizationPipelineV2/component/pipeline/providers/OptimizationPipelineProvider';

function getDataQualityMeta(syntheticData, fallbackMeasured = false) {
    if (syntheticData === true) return { value: 'Synthetic', severity: 'warning' };
    if (syntheticData === false) return { value: 'Measured', severity: 'success' };
    if (fallbackMeasured) return { value: 'Measured', severity: 'success' };
    return { value: 'Missing', severity: 'error' };
}

export default function UnitNode(props) {
    const { optimizationPipelineDetail, optimizationPipelineDetailsLoading, optimizationPipelineDetailsLoaded, openSidebar, openPopup } = useOptimizationPipeline();

    const syntheticData = optimizationPipelineDetail?.merged_meta?.synthetic_data;
    const mergerInputs = optimizationPipelineDetail?.merged_meta?.merger?.inputs;
    const dataQuality = getDataQualityMeta(syntheticData);
    const inputRows = [];

    if (mergerInputs && typeof mergerInputs === 'object') {
        Object.entries(mergerInputs).forEach(([key, value]) => {
            const fallbackMeasured = !!(value && typeof value === 'object' && (value.timestamp || value.original_timestamp || value.data_origin));
            const meta = getDataQualityMeta(value?.synthetic_data, fallbackMeasured);
            inputRows.push({ label: key, value: meta.value, severity: meta.severity });
        });
    }

    return (
        <Node ref={props.anchorRef} title='Unit' icon={PiFactoryDuotone} fit={props.fit} loading={optimizationPipelineDetailsLoading || !optimizationPipelineDetailsLoaded}>

            <div className='w-full flex flex-col gap-8'>

                <NodeValue label='Data Type' value={dataQuality.value} severity={dataQuality.severity} />
                <NodeValueList rows={inputRows} />

                <div className='w-full flex flex-col gap-10'>
                    <div className='w-full flex gap-10'>
                        <Button genericType='DETAILS' onClick={() => { openSidebar({ type: 'UNIT_MEASUREMENT', query: '' }); }} />
                        <Button genericType='HISTORY' onClick={() => { openPopup({ type: 'UNIT_HISTORY' }); }} />
                    </div>
                </div>

            </div>

        </Node>
    );
}